/* eslint-disable no-undef */
import React, { useState, useCallback, useRef } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import 'src/styles/fonts/MCGlobalFonts.css';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
// import Popup from 'src/common/refactoredComponents/popup/Popup';
// import Button from 'src/common/components/button/Button';
// import TimeOut from 'src/assets/images/Time-Out.svg';
import LogoutActions from 'src/common/components/logoutActions';
import { hideScrolling, resumeScrolling } from 'src/utils/util';
import SessionTimeOutPopUp from './SessionTimeoutPopup';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SessionTimeout = () => {
    const [events] = useState(['click', 'load', 'scroll', 'keydown', 'wheel']);
    const [, setSecond] = useState(0);
    const [, setMinute] = useState(0);
    const [isOpen, setOpen] = useState(false);
    const [isAuthenticated, setAuthenticated] = useState(false);
    const [logoutRquested, setLogoutRquested] = useState(false);
    const [timeoutId] = useState([]);
    const [intervalId] = useState([]);

    let timeStamp;
    var warningInactiveInterval = useRef();
    let startTimerInterval = useRef();

    let isAuthenticatedWithHybris = useSelector(
        (state) =>
            state.loginReducer.isAuthenticatedWithHybris ||
            JSON.parse(localStorage.getItem('userAuthenticated'))
    );

    useEffectWithErrorLogging(() => {
        if (isAuthenticatedWithHybris) {
            setAuthenticated(true);
        } else {
            setAuthenticated(false);
        }
    }, [isAuthenticatedWithHybris]);

    // start inactive check
    let timeChecker = () => {
        startTimerInterval.current = setTimeout(() => {
            let storedTimeStamp = sessionStorage.getItem('lastTimeStamp');
            warningInactive(storedTimeStamp);
        }, 60000);
        timeoutId.push(startTimerInterval.current);
    };

    // warning timer
    let warningInactive = (timeString) => {
        // clearTimeout(startTimerInterval.current);
        while (timeoutId.length) clearTimeout(timeoutId.pop());
        warningInactiveInterval.current = setInterval(() => {
            const popTimeHour = Math.floor(
                process.env.SESSION_TIMEOUT_POPUP_TIME / 60
            ); // 118 i.e 2 min before session time out popup shown
            const popTimeMin = process.env.SESSION_TIMEOUT_POPUP_TIME % 60;
            const maxTimeHour = Math.floor(
                process.env.SESSION_TIMEOUT_TOTAL_TIME / 60
            ); //ideal time for user in minutes 120;
            const maxTimeMin = process.env.SESSION_TIMEOUT_TOTAL_TIME % 60;
            const diff = moment.duration(moment().diff(moment(timeString)));
            const hourPast = diff.hours();
            const minPast = diff.minutes();
            const leftSecond = 60 - diff.seconds();
            if (
                isAuthenticated &&
                minPast === popTimeMin &&
                hourPast === popTimeHour
            ) {
                setSecond(leftSecond);
                setMinute(minPast);
                setOpen(true);
                removeEvents();
            }

            if (maxTimeMin <= minPast && maxTimeHour <= hourPast) {
                // clearInterval(warningInactiveInterval.current);
                while (intervalId.length) clearInterval(intervalId.pop());
                sessionStorage.removeItem('lastTimeStamp');
                setOpen(false);
                logout();
            }
        }, 1000);
        intervalId.push(warningInactiveInterval.current);
    };

    // reset interval timer
    let resetTimer = useCallback(() => {
        // clearTimeout(startTimerInterval.current);
        while (timeoutId.length) clearTimeout(timeoutId.pop());
        // clearInterval(warningInactiveInterval.current);
        while (intervalId.length) clearInterval(intervalId.pop());
        if (isAuthenticated && !isOpen) {
            timeStamp = moment();
            sessionStorage.setItem('lastTimeStamp', timeStamp);
        }
        timeChecker();
    }, [isAuthenticated]);

    // handle close popup
    const handleClose = () => {
        setOpen(false);
        // clearInterval(warningInactiveInterval.current);
        while (timeoutId.length) clearTimeout(timeoutId.pop());
        resetTimer();
    };
    useEffectWithErrorLogging(() => {
        if (isOpen) {
            removeEvents();
            hideScrolling();
        } else {
            resumeScrolling();
        }
    }, [isOpen]);

    const removeEvents = () => {
        events.forEach((event) => {
            window.removeEventListener(event, resetTimer);
        });
    };

    useEffectWithErrorLogging(() => {
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });
        timeChecker();
        return () => {
            // clearTimeout(startTimerInterval.current);
            while (timeoutId.length) clearTimeout(timeoutId.pop());
            //   resetTimer();
        };
    }, [resetTimer, events, timeChecker]);

    useEffectWithErrorLogging(() => {
        if (isAuthenticated) {
            resetTimer();
        }
    }, [isAuthenticated]);

    const logout = () => {
        setLogoutRquested(true);
    };

    // const sessionTimeOutPopUp = () => {
    //     return (
    //         <>
    //             <Popup
    //                 onClose={handleClose}
    //                 title={' '}
    //                 width={'192px'}
    //                 img={TimeOut}
    //                 imageMarginLeftDesktop={'187px'}
    //                 imageMarginLeftMobile={'148px'}
    //             >
    //                 <SessionOutPopUpDiv divHeight={'140px'} isOpen={isOpen}>
    //                     <PopUpText
    //                         flexGrow={'1'}
    //                         height={'auto'}
    //                         font={'14px Avenir Next World'}
    //                         lineHeight={'20px'}
    //                     >
    //                         <DesktopView>
    //                             <PopUpTitleText>
    //                                 You have been inactive for{' '}
    //                                 {process.env.SESSION_TIMEOUT_POPUP_TIME}{' '}
    //                                 minutes.
    //                             </PopUpTitleText>
    //                             <br />
    //                             <PopUpTitleSubText1>
    //                                 Please respond or you will be logged out to
    //                                 ensure your{' '}
    //                             </PopUpTitleSubText1>
    //                             <PopUpTitleSubText2>
    //                                 account’s security
    //                             </PopUpTitleSubText2>
    //                         </DesktopView>
    //                         <MobileView>
    //                             <PopUpTitleText>
    //                                 You have been inactive for{' '}
    //                                 {process.env.SESSION_TIMEOUT_POPUP_TIME}{' '}
    //                                 minutes.
    //                             </PopUpTitleText>
    //                             <PopUpTitleSubText1 mobileMarginTop={'1%'}>
    //                                 Please respond or you will be logged out to
    //                                 ensure your{' '}
    //                             </PopUpTitleSubText1>
    //                             <PopUpTitleSubText2>
    //                                 account’s security
    //                             </PopUpTitleSubText2>
    //                         </MobileView>
    //                     </PopUpText>
    //                     <PopUpDesktopWrap flexDirection="row-reverse">
    //                         <Button
    //                             show={true}
    //                             width={'100px'}
    //                             height={'38px'}
    //                             primary={true}
    //                             borderRadius={'19px'}
    //                             margin={'5px'}
    //                             fontSize={'15px'}
    //                             fontFamily={'AvenirNextWorld Demi'}
    //                             clicked={handleClose}
    //                         >
    //                             <div style={{ whiteSpace: 'nowrap' }}>
    //                                 {'OK'}
    //                             </div>
    //                         </Button>
    //                     </PopUpDesktopWrap>
    //                 </SessionOutPopUpDiv>
    //             </Popup>
    //         </>
    //     );
    // };
    return (
        <>
            <LogoutActions logoutRquested={logoutRquested} />
            {/* {isOpen && sessionTimeOutPopUp()} */}
            {isOpen && (
                <SessionTimeOutPopUp
                    isOpen={isOpen}
                    handleClose={handleClose}
                />
            )}
        </>
    );
};

export default SessionTimeout;

export const SessionOutPopUpDiv = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    height: ${({ divHeight }) => (divHeight ? divHeight : '63px')};
    ${media.mobileDevice`
         width:310px;
         height:160px;
         overflow:${({ isOpen }) => (isOpen ? 'hidden' : 'unset')};
    `}
`;

export const PopUpText = styled.div`
    height: ${({ webHeight }) => (webHeight ? webHeight : '155px')};
    font: ${({ font }) => (font ? font : '16px Avenir Next World')};
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;
    padding-top: 12px;
    line-height: ${({ lineHeight }) => lineHeight};
    flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : '0')};
    ${media.mobileDevice` 
        height: ${({ height }) => (height ? height : '190px')};
        font: ${({ font }) => (font ? font : '15px Avenir Next World')};;
        font-family:'AvenirNextWorld Regular';
        line-height: ${({ lineHeight }) => lineHeight};
    `};
`;

export const PopUpDesktopWrap = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : ''};
    margin-right: 150px;
    ${media.mobileDevice` 
        flex-wrap:wrap;
        margin-right:92px;
    `};
`;

export const PopUpTitleText = styled.b`
    margin-left: 10%;
    font-size: 18px;
    ${media.mobileDevice` 
        font-size: 14px;
        margin-left: 2%;
        display: block;
        margin-top : ${({ mobileMarginTop }) =>
            mobileMarginTop ? mobileMarginTop : '0px'};
    `};
`;

export const PopUpTitleSubText1 = styled.span`
    margin-left: 21px;
    ${media.mobileDevice` 
        margin-left:0px;
        font-size:12px;
        display : inline-block;
        margin-top : ${({ mobileMarginTop }) =>
            mobileMarginTop ? mobileMarginTop : '0px'};
    `};
`;

export const PopUpTitleSubText2 = styled.span`
    margin-left: 136px;
    ${media.mobileDevice` 
        margin-left:103px;
        font-size:12px;
    `};
`;

export const MobileView = styled.div`
    display: none;

    ${media.mobileDevice`
        display: block;
    `}
`;
export const DesktopView = styled.div`
    display: block;

    ${media.mobileDevice`
        display: none;
    `}
`;
